<div class="card">
  <p-toast />
  <p-fileupload
    #fileUploadRef
    name="myfile[]"
    [multiple]="true"
    accept="application/pdf"
    [fileLimit]="1"
    [maxFileSize]="MAX_FILE_SIZE"
    [customUpload]="true"
    (uploadHandler)="onTemplatedUpload($event)"
    (onError)="errorUploadingFile($event)"
    (onImageError)="errorUploadingFile($event)"
  >
    <ng-template
      pTemplate="header"
      let-files
      let-chooseCallback="chooseCallback"
      let-clearCallback="clearCallback"
      let-uploadCallback="uploadCallback"
    >
      <div class="header-content">
        <div class="action-file-upload">
          <p-button
            label="Select Folder"
            (onClick)="choose($event, chooseCallback)"
            icon="pi pi-images"
            [rounded]="true"
            [outlined]="true"
          />
          <p-button
            label="Upload file"
            (onClick)="uploadEvent(uploadCallback)"
            icon="pi pi-cloud-upload"
            [rounded]="true"
            [outlined]="true"
            severity="success"
            [disabled]="!files || files.length === 0"
          />
          <p-button
            label="Remove File Selected"
            (onClick)="clearCallback()"
            icon="pi pi-times"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="danger"
            [disabled]="!files || files.length === 0"
          />
        </div>

        <div *ngIf="isUploading" style="width: 100%">
          <span style="color: var(--text-color); font-size: 0.875rem; margin-bottom: 0.25rem; display: block"
            >Uploading file...</span
          >
          <p-progressbar [value]="uploadProgress" [showValue]="true"></p-progressbar>
        </div>

        <div *ngIf="!isUploading" style="width: 100%">
          <p-progressbar [value]="totalSizePercent" [showValue]="false">
            <span class="whitespace-nowrap text-color">{{ formatSize(totalSize) }} / 100 MB</span>
          </p-progressbar>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="file"></ng-template>
    <ng-template pTemplate="uploadedFile"></ng-template>
    <ng-template
      pTemplate="content"
      let-files
      let-uploadedFiles="uploadedFiles"
      let-removeFileCallback="removeFileCallback"
      let-removeUploadedFileCallback="removeUploadedFileCallback"
    >
      <div class="content">
        <div *ngIf="files?.length > 0">
          <div class="file-list">
            <div class="file-row" *ngFor="let file of files; let i = index">
              <div class="file-info">
                <i class="pi pi-file-pdf" style="font-size: 1.5rem; color: #74d4ff"></i>
                <span class="file-name">{{ file.name }}</span>
              </div>
              <div class="file-actions">
                <span class="text-color-secondary">{{ formatSize(file.size) }}</span>
                <p-button
                  icon="pi pi-times"
                  (click)="onRemoveTemplatingFile($event, file, removeFileCallback, i)"
                  severity="danger"
                  size="small"
                />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="uploadedFiles?.length > 0" class="mt-4">
          <h5 class="text-color mb-3">Completed</h5>
          <div class="file-list">
            <div class="file-row" *ngFor="let file of uploadedFiles; let i = index">
              <div class="file-info">
                <i class="pi pi-file-pdf" style="font-size: 1.5rem; color: #4ade80"></i>
                <span class="file-name">{{ file.name }}</span>
              </div>
              <div class="file-actions">
                <span class="text-color-secondary">{{ formatSize(file.size) }}</span>
                <p-badge value="Completed" severity="success" />
                <p-button icon="pi pi-times" (onClick)="removeUploadedFileCallback(i)" severity="danger" size="small" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="empty">
      <div class="empty-file">
        <i class="pi pi-cloud-upload cloud-icon"></i>
        <div class="empty-text">Drag and drop files here to upload. Allowed Types PDF</div>
        <div class="empty-subtext">or click the icons above to browse your device</div>
      </div>
    </ng-template>
  </p-fileupload>
</div>
